module.exports = __webpack_public_path__ + "static/media/blue-element-gs.22fd2193.svg";